import { createFileRoute } from "@tanstack/react-router";
import { HowPencilWiseWorks } from "@/screens/HowPencilWiseWorks";
// MA-870 (D-PUX-20): "How PencilWise works", linked from Settings › Help.
export const Route = createFileRoute("/parent/settings/how-it-works")({ component: HowPencilWiseWorks });
